import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import { getUsersById } from "helpers/backend_helper";


const ProfileMenu = props => {
  const user = JSON.parse(localStorage.getItem("authUser")) || {};
  const userId = user.user_id;
  const [profile, setProfile] = useState(user);
  const [menu, setMenu] = useState(false);
  const [photoFailed, setPhotoFailed] = useState(false);
  const navigate = useNavigate();

  const name =
    profile.name ||
    profile.username ||
    profile.full_name ||
    profile.email ||
    profile.primary_mail_id ||
    "Admin";
  const email =
    profile.email ||
    profile.primary_mail_id ||
    (() => {
      try {
        return JSON.parse(localStorage.getItem("email")) || "";
      } catch {
        return "";
      }
    })();
  const photo =
    profile.photo_url ||
    profile.profile_image ||
    profile.photo ||
    "";
  const roleName = localStorage.getItem("userRole") || "";
  const initial = name.trim().charAt(0).toUpperCase() || "A";

  useEffect(() => {
    if (!userId) return undefined;

    let cancelled = false;
    getUsersById(userId)
      .then((response) => {
        const fetchedProfile = response?.data?.user || response?.data?.data;
        if (!cancelled && fetchedProfile) {
          setProfile((currentProfile) => ({
            ...currentProfile,
            ...fetchedProfile,
          }));
          setPhotoFailed(false);
        }
      })
      .catch(() => {
        // Keep the login profile as a fallback if the profile request fails.
      });

    return () => {
      cancelled = true;
    };
  }, [userId]);
  
  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("selected_student");
    localStorage.removeItem("student_selected");
    localStorage.removeItem("authUser");
    localStorage.removeItem("token");
    localStorage.removeItem("primary_mail_id");
    localStorage.removeItem("userRole");
    localStorage.removeItem("email");
    localStorage.removeItem("role"); 
    localStorage.removeItem("activeTab");
    localStorage.removeItem("paymentResponse");
    localStorage.removeItem("selectedStudent");
    localStorage.removeItem("profileImage");

    navigate("/logout");
  };

  return (
    <React.Fragment>
      <div
        onMouseEnter={() => setMenu(true)}
        onMouseLeave={() => setMenu(false)}
        style={{ display: "inline-block" }}
      >
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item d-flex align-items-center"
          id="page-header-user-dropdown"
          tag="button"
          aria-label={`Logged in as ${name}`}
        >
          <span
            style={{
              width: "34px",
              height: "34px",
              borderRadius: "50%",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              background: "var(--talc-primary, #da7938)",
              color: "#fff",
              fontSize: "15px",
              fontWeight: 700,
              overflow: "hidden",
              flexShrink: 0,
              boxShadow:
                "0 0 0 2px #fff, 0 0 0 4px var(--talc-primary, #da7938)",
            }}
          >
            {photo && !photoFailed ? (
              <img
                src={photo}
                alt={name}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
                onError={() => setPhotoFailed(true)}
              />
            ) : (
              initial
            )}
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <div className="px-3 py-2">
            <div className="fw-bold" style={{ fontSize: "13px", color: "var(--talc-text-primary, #1e293b)" }}>
              {name}
            </div>
            {email && (
              <div className="text-muted" style={{ fontSize: "11px", wordBreak: "break-all" }}>
                {email}
              </div>
            )}
            {roleName && (
              <div
                className="mt-1"
                style={{ fontSize: "10px", fontWeight: 700, letterSpacing: "0.4px", textTransform: "uppercase", color: "var(--talc-primary, #da7938)" }}
              >
                {roleName}
              </div>
            )}
          </div>
          <div className="dropdown-divider" />
          <DropdownItem tag="a" href="/profile">
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}{" "}
          </DropdownItem>
          <DropdownItem tag="a" href="/change-password">
            <i className="bx bx-key font-size-16 align-middle me-1" />
            {props.t("ChangePassword")}
          </DropdownItem>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item" onClick={handleLogout}>
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
      </div>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
